export default "__VITE_ASSET__BvYUO94S__"